export const elementIds = {
  firstName: 'field13',
  lastName: 'field14',
  emailAddress: 'field12',
  company: 'field16',
  phone: 'field15',
  notes: 'field18',
  optIn: 'field20',
  jobLevel: 'field22',
  jobTopic: 'jobTopic',
};

const emailValidator = new RegExp('[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?'); // eslint-disable-line max-len
const phoneValidator = new RegExp(/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/);

export const validateFields = (formData, addJobTopicField, modifyMessageField) => ({
  firstName: !formData.firstName.trim(),
  lastName: !formData.lastName.trim(),
  emailAddress: !formData.emailAddress.trim(),
  notes: modifyMessageField && !formData.notes.trim(),
  invalidEmail: formData.emailAddress.trim() && !formData.emailAddress.match(emailValidator),
  invalidPhone: formData.phone && formData.phone.trim() && !formData.phone.match(phoneValidator),
  invalidNotes: formData.notes && formData.notes.trim() && (formData.notes.trim().length > 500),
  jobLevel: !formData.jobLevel,
  jobTopic: addJobTopicField && !formData.jobTopic,
  jobLevelError: formData.jobLevelError,
  jobTopicError: formData.jobTopicError,
});
